<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
            <DocumentsNav></DocumentsNav>
        </b-col>
      </b-row>
    </div>
    <div>
      <div class="documents-body">
        <div class="documents-content p-4">
          <b-row no-gutters>
            <b-col sm="12" md="8">
              <div class="modal-form">
                <div>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Label Name</h6>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label="Label"
                        class="mt-1 secondary-label"
                        :invalid-feedback="errorMessage('name')"
                        :state="isValid('name')"
                      >
                        <b-form-input
                          v-model="form.name"
                          placeholder="Enter Label Name"
                          maxlength="50"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider" />
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Instruction</h6>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label="Instruction"
                        class="mt-1 secondary-label"
                        :invalid-feedback="errorMessage('description')"
                        :state="isValid('description')"
                      >
                        <b-form-textarea
                          id="textarea"
                          v-model="form.description"
                          placeholder="Enter Instruction"
                          rows="3"
                          max-rows="6"
                          maxlength="1000"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider" />
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Notes</h6>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label="Notes"
                        class="mt-1 secondary-label"
                        :invalid-feedback="errorMessage('notes')"
                        :state="isValid('notes')"
                      >
                        <b-form-textarea
                          id="textarea"
                          v-model="form.notes"
                          placeholder="Enter Notes"
                          rows="3"
                          max-rows="6"
                          maxlength="1000"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Number of Uploads</h6>
                    </b-col>
                    <b-col>
                      <b-form-group label="Uploads" class="mt-1 secondary-label"
                        :invalid-feedback="errorMessage('no_of_uploads')"
                        :state="isValid('no_of_uploads')"
                      >
                        <b-form-select
                          v-model="form.no_of_uploads"
                          :options="uploadsOptions"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        size="lg"
                        variant="primary"
                        class="mt-4 save-button"
                        type="submit"
                        :block="true"
                        :disabled="loading"
                        @click="showModal('create-document')"
                      >Save</b-button>
                    </b-col>
                    <b-col cols="9"></b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col sm="12" md="4"></b-col>
          </b-row>
        </div>
      </div>
    </div>
    <b-modal id="create-document" title="Confirm Changes">
      <div class="modal-form">
        <p class="text-center">Do you want to save the changes you made?</p>
      </div>
      <div slot="modal-footer">
          <b-button
            variant="ghost"
            v-bind:disabled="loading"
            class="btn-cancel"
            style="margin-right: .25rem;"
            @click="hideModal('create-document')"
          >Cancel</b-button>
          <b-button
            variant="primary"
            v-bind:disabled="loading"
            style="margin-left: .25rem;"
            @click="saveDocument"
          >
            <template v-if="loading">Saving...</template>
            <template v-else>Save</template>
          </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DocumentsNav from "./DocumentsNav.vue";
import { mapState } from "vuex";

export default {
    name: "Documents",
    data() {
        return {
            form: {
                uuid: null,
                name: "",
                description: "",
                notes: "",
                no_of_uploads: 1
            },
            uploadsOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        };
    },
    computed: {
        ...mapState("documents", ["loading", "errors", "document"])
    },
    components: {
        DocumentsNav
    },
    created() {
        this.viewDocument();
    },
    methods: {
        async viewDocument() {
            this.$store.dispatch("documents/resetErrors");
            await this.$store.dispatch("documents/viewDocument").then(() => {
                if (this.errors == null) {
                  if (this.document !== null) {
                    this.form = this.document;
                  }
                }
            });
        },
        async saveDocument() {
            this.$store.dispatch("documents/resetErrors");

            if (this.form.uuid == null) {
                await this.$store
                    .dispatch("documents/createDocument", this.form)
                    .then(() => {
                        if (this.errors == null) {
                            this.viewDocument();
                            this.hideModal("create-document");
                        } else {
                            this.hideModal("create-document");
                        }
                    });
            } else {
                await this.$store
                    .dispatch("documents/updateDocument", this.form)
                    .then(() => {
                        if (this.errors == null) {
                            this.viewDocument();
                            this.hideModal("create-document");
                        } else {
                            this.hideModal("create-document");
                        }
                    });
            }
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        showModal(modal) {
            this.$store.dispatch("wallet/resetErrors");

            this.$root.$emit("bv::show::modal", modal);
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        }
    }
};
</script>

<style lang="scss" scoped>
input::placeholder, textarea::placeholder {
  color: rgb(204, 204, 204);
}
</style>
